// removed by extract-text-webpack-plugin
module.exports = {"container":"change-rsvp__container__O3K3x","button":"change-rsvp__button__2DkvN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rsvp_modal/change-rsvp.scss
// module id = 1254
// module chunks = 1